import commaSeparator from "../../../utils/CommaSeparator";
import utilsFunction from "../../../utils/utilsFunction";
import {submitDocumentFormAction} from "../../Store/SubmitDocumentForm";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";

export const CalculateInformationUnderTable = (newTableData) => {
  let sumOfBedToCalculate = 0;
  let sumOfBesToCalculate = 0;
  newTableData.forEach((v) => {
    sumOfBedToCalculate += Number((v.bed + "").replaceAll(",", ""));
    sumOfBesToCalculate += Number((v.bes + "").replaceAll(",", ""));
  });
  const remainBalance = Math.abs(sumOfBesToCalculate - sumOfBedToCalculate);
  return {
    sumOfBed: commaSeparator(sumOfBedToCalculate),
    sumOfBes: commaSeparator(sumOfBesToCalculate),
    remainToBalance: commaSeparator(remainBalance),
  };
};


export const drawNew = (sendData) => {
  let sumOfBed, sumOfBes, remainToBalance;

  sumOfBed = utilsFunction.removeComma(sendData.sumOfBed);
  sumOfBes = utilsFunction.removeComma(sendData.sumOfBes);
  remainToBalance = utilsFunction.removeComma(sendData.remainToBalance);


  const tempChartDataUnderTable = {}

  const total = +sumOfBes + +sumOfBed;

  tempChartDataUnderTable.besWidth = (+sumOfBes * 100) / total;
  tempChartDataUnderTable.bedWidth = (+sumOfBed * 100) / total;
  tempChartDataUnderTable.remainToBalance = Math.abs(+sumOfBed - +sumOfBes);
  tempChartDataUnderTable.isShow = total !== 0;
  return tempChartDataUnderTable;
};

export const downloadFileHandler = (tb) => {
  const myTableData = [...tb];
  const format = {
    year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit",
  };
  const fileName = "روانحساب_من_" + new Date().toLocaleDateString("fa-ir", format);
  utilsFunction.makeReadyToDownloadFile(myTableData, fileName, "txt");
};

export const onPrintHandler = (clickOnPrintRef) => {
  console.log(clickOnPrintRef)

}

export const editCellInSubmitForm = ({tableData, selectedRowId, myKey, value, dispatch, needToDelete}) => {


  let newTableData = tableData.map(row => {
    const myRow = {...row}
    if (myRow.uniqId === selectedRowId) {
      myRow[myKey] = value;
    }
    return myRow
  });

  if (needToDelete !== undefined) {

    newTableData = newTableData.map(row => {
      const myRow = {...row}
      if (myRow.uniqId === selectedRowId) {
        myRow[needToDelete.removeKey] = "";
      }
      return myRow
    })


  }


  dispatch(submitDocumentFormAction.fillInput({tableData: newTableData}))


}
export const deleteRowInSubmitForm = ({
                                        tableData, selectedRowId, dispatch,
                                      }) => {

  const newTableData = tableData.filter(v => v.uniqId !== selectedRowId)
  dispatch(submitDocumentFormAction.fillInput({tableData: newTableData}))


}

export const getRowData = ({type, value, rowId, dispatch, tableData}) => {

  return new Promise((resolve, reject) => {
    let url;
    if (type === "moien") {
      url = "/accountingDocument/index.php?request=subsidiaryDetail&value=" + value
    } else {
      url = "/accountingDocument/?request=accountDetail&id=" + value
    }


    _axios
      .get(prefixUrl() + url)
      .then((res) => {
        const data = res.data;
        if (data.status) {


          const newTableData = tableData.map(v => {

            let row = {...v}
            if (row.uniqId === rowId) {

debugger
              const needData = {
                hasSubAccount: data.data.hasSubAccount,
                accountTitle: data.data.accountTitle,
                accountCode: data.data.accountCode,
                description: data.data.description,
                level1Code: data.data.level1Code,
                level1Name: data.data.level1Name,
                level2Code: data.data.level2Code,
                level2Name: data.data.level2Name,
                level3Code: data.data.level3Code,
                level3Name: data.data.level3Name,
                level4Code: data.data.level4Cod,
                level4Name: data.data.level4Nam,
                level4FloatingCode: data.data.level4FloatingCod,
                floatingAccount: data.data.floatingAccount,
                floatingAccountList: data.data.floatingAccountList,
              }

              const newNeedData = {
                description: data.data.description,
                floatingAccount: data.data.floatingAccount,
                floatingAccountList: data.data.floatingAccountList,
                accountCode: data.data.accountCode,

                hasSubAccount: data.data.hasSubAccount,
                level1Code: data.data.level1Code,
                level1Name: data.data.level1Name,
                level2Code: data.data.level2Code,
                level2Name: data.data.level2Name,
                level3Code: data.data.level3Code,
                level3Name: data.data.level3Name,
                level4Code: data.data.level4Code,
                level4FloatingCode: data.data.level4FloatingCode,
                level4Name: data.data.level4Name,
                value: data.data.value,

              }
              row = {...row, ...newNeedData}
            }

            return row
          })


          dispatch(submitDocumentFormAction.fillInput({tableData: newTableData}))
          resolve(newTableData)

        }
      });
  })

}


export const removeNeededValue = ({tableData, selectedRowId, dispatch, removeValue}) => {


  const newTableData = tableData.map(row => {
    const myRow = {...row}
    if (myRow.uniqId === selectedRowId) {
      myRow[removeValue] = 0;
    }
    return myRow
  })

  dispatch(submitDocumentFormAction.fillInput({tableData: newTableData}))


}

export const addIndexRowToTable = (tableData, dispatch) => {

  const newTableData = [...tableData]?.map((v, index) => {
    const row = {...v}
    row.indexRow = index + 1
    return row
  })
  dispatch(submitDocumentFormAction.fillInput({tableData: newTableData}))
}
export const addUniqId = (MData) => {
  let myData = [...MData]
  return myData.map(v => {
    const row = {...v}
    row.uniqId = utilsFunction.randomNumberGenerator();
    return row
  })
}

export const addTafsiliOrDirectMoien = (tableData) => {
  const newTableData = [...tableData]

  const temp = newTableData.map(v => {

    const row = {...v}

    if (row.level3Code === row.accountCode) {

      row.tafsili = "";

    } else {

      console.log(row)
      row.accountCode = row.level3Code
      debugger
      const findedValue = row?.holder?.find(v => v.value === row.level4Code)
      debugger
      row.tafsili = findedValue

    }

    // row.accountCode = row.level3Code
    // row.tafsili = row.level4Code

    return row


  })

  return temp

}

export const holderAndDirectMoien = (sendData) => {
  const mySendData = {...sendData}


  mySendData.tableData.forEach(row => {


    //row.tafsili = row.level4Code

    const value = row.level3Code;

    const filteredData = mySendData.documentPageData.accounts.filter(row => row.value === value)[0]
    //debugger
    row['holder'] = filteredData?.hasSubAccount ? JSON.stringify(filteredData) : undefined

    if (filteredData?.hasSubAccount) {
      debugger
      row.tafsili = JSON.parse(row['holder'])?.accountCodes?.find(v => v.label === row.level4Code)?.value
    }
  })

  debugger
  return mySendData
}
